import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_STAFF } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import getStaffEmployeeModel from '@/store/modules/models/staffEmployee'

const staff = {
  namespaced: true,
  state: buildInitialState({
    staff: [],
    ...getStaffEmployeeModel()
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setStaff: (state, staff) => {
      state.staff = staff
    },
    setStaffEmployee: (state, staffEmployee) => {
      state.id = staffEmployee.id
      state.user = staffEmployee.user
      state.commissionTiers = staffEmployee.commissionTiers
      state.userId = staffEmployee.userId
      state.employeeTypeId = staffEmployee.employeeTypeId
      state.corporateName = staffEmployee.corporateName
      state.ein = staffEmployee.ein
      state.payAmount = staffEmployee.payAmount
      state.payTypeId = staffEmployee.payTypeId
      state.payFrequencyId = staffEmployee.payFrequencyId
      state.workedHoursAverage = staffEmployee.workedHoursAverage
      state.corporateEmailAddress = staffEmployee.corporateEmailAddress
      state.active = staffEmployee.active
      state.startDate = staffEmployee.startDate
      state.endDate = staffEmployee.endDate
      state.zohoUserId = staffEmployee.zohoUserId
    },
    clearStaff: (state) => {
      state.staff = []
    },
    clearStaffEmployee: (state) => {
      state.id = null
      state.user = {}
      state.commissionTiers = []
      state.userId = null
      state.employeeTypeId = null
      state.corporateName = null
      state.ein = null
      state.payAmount = null
      state.payTypeId = null
      state.payFrequencyId = null
      state.workedHoursAverage = null
      state.corporateEmailAddress = null
      state.active = null
      state.startDate = null
      state.endDate = null
      state.zohoUserId = null
    }
  },
  actions: {
    getStaffWithFilters ({ dispatch, rootGetters }) {
      return dispatch('getStaff', { ...rootGetters['staffFilters/getSearchObject'] })
    },
    getStaff: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting internal employees, please wait...' })

      return api.doGet({ path: PATH_STAFF, parameters: filters })
        .then(json => json.data)
        .then(staff => {
          commit('updateStatus', { status: COMPLETE })
          commit('setStaff', staff)
          hideProgressModal({ dispatch })
          return staff
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to get internal employees')
        })
    },
    getStaffEmployee ({ commit, dispatch }, id = null) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting internal employee, please wait...' })
      return api.doGet({ path: PATH_STAFF, parameters: Object.assign({}, { id: id }) })
        .then(json => json.data)
        .then(staffEmployee => {
          commit('updateStatus', { status: COMPLETE })
          commit('setStaffEmployee', staffEmployee)
          hideProgressModal({ dispatch })
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to get internal employee')
        })
    },
    saveStaffEmployee: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving internal employee, please wait...' })

      return api.doPost({ path: PATH_STAFF, data: state })
        .then(response => {
          if (!response.data) {
            if (response.errorMessage) {
              throw new Error(response.errorMessage)
            }
            throw new Error('Unable to save internal employee.')
          }
          commit('clearStaffEmployee')
          commit('updateStatus', { status: COMPLETE })
          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Internal employee saved')
          return response
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, error || 'Unable to save internal employee.')
          throw error
        })
    },
    updateStaffEmployee: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Updating internal employee, please wait...' })

      return api.doPut({ path: PATH_STAFF, data: state })
        .then(response => {
          if (!response.data) {
            if (response.errorMessage) {
              throw new Error(response.errorMessage)
            }
            throw new Error('Unable to update internal employee.')
          }
          commit('updateStatus', { status: COMPLETE })
          commit('clearStaffEmployee')
          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Internal employee updated')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, error || 'Unable to update internal employee.')
          throw error
        })
    },
    clearStaffEmployee ({ commit }) {
      commit('clearStaffEmployee')
    }
  }
}

export default staff
